import React from 'react';
import Grid from '@material-ui/core/Grid';
import FieldData from './FieldData';
import Button from '@material-ui/core/Button';
import { prettyDate } from '../../../../utils/date';
import useStyles from './styles';

const SchedulingBarcodeDetail = ({ scheduling, onConfirm, onCancel }) => {
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FieldData label="Filial / Planta">
            {`${scheduling?.branch_name ?? ''} / ${scheduling?.plant_name ?? ''}`}
          </FieldData>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item md={6} xs={12}>
          <FieldData label="Data">
            {scheduling?.scheduling_date && prettyDate(scheduling?.scheduling_date)}
          </FieldData>
        </Grid>
        <Grid item md={6} xs={12}>
          <FieldData label="Placa do caminhão">
            {scheduling?.truck_plate}
          </FieldData>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FieldData label="Produto / Volume">{`${scheduling?.product ?? ''} / ${scheduling?.volume ? `${scheduling?.volume} (Kg)`: '' }`}</FieldData>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FieldData label="Motorista / CNH">
            {`${scheduling?.driver_name ?? ''} / ${scheduling?.driver_document ?? ''}`}
          </FieldData>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={2} xs={2}>
          <Button
            color="primary"
            variant="contained"
            size="large"
            disabled={scheduling?.id === undefined}
            onClick={onConfirm}
            className={classes.btns}
          >
            Confirmar
          </Button>
        </Grid>
        <Grid item md={2} xs={2}>
          <Button
            color="primary"
            size="large"
            className={classes.btns}
            onClick={onCancel}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default SchedulingBarcodeDetail;
